// src/pages/technicalAnalysis/utils/clusterProcessing.js

export const processClusterData = (rawData) => {
    const clusterTypes = {
      'Entity': { color: '#688ee0', description: 'Data structures and domain objects' },
      'Service': { color: '#9dc3ff', description: 'Business logic and application services' },
      'DataAccess': { color: '#6aad87', description: 'Database and persistence operations' }
    };
  
    // Process summary data
    const summary = {
      totalClasses: rawData.length,
      clusters: Object.entries(clusterTypes).map(([type, info]) => ({
        title: type,
        value: rawData.filter(item => item.type === type).length,
        color: info.color,
        description: info.description
      }))
    };
  
    // Process detailed data
    const details = rawData.reduce((acc, item) => {
      if (!acc[item.type]) {
        acc[item.type] = {
          classes: [],
          patterns: new Set(),
          keyMetrics: {
            avgComplexity: 'Medium',
            avgDependencies: 0,
            avgConfidence: 0
          }
        };
      }
  
      // Add class details
      const classDetails = {
        name: item.attributes.class_name,
        confidence: Math.round(item.confidence_score * 100),
        dependencies: item.attributes.dependencies?.length || 
                     item.attributes.related_entities?.length || 0,
        evidence: item.classification_evidence,
        type: item.type,
        operations: item.attributes.operations || [],
        attributes: item.attributes.attributes || [],
        sourceFile: item.source_file
      };
  
      acc[item.type].classes.push(classDetails);
      
      // Update metrics
      acc[item.type].keyMetrics.avgConfidence += item.confidence_score * 100;
      acc[item.type].keyMetrics.avgDependencies += classDetails.dependencies;
  
      return acc;
    }, {});
  
    // Calculate averages
    Object.values(details).forEach(cluster => {
      const count = cluster.classes.length;
      cluster.keyMetrics.avgConfidence = Math.round(cluster.keyMetrics.avgConfidence / count);
      cluster.keyMetrics.avgDependencies = Math.round(cluster.keyMetrics.avgDependencies / count);
    });
  
    return { summary, details };
  };
  